/* global axios */
import ApiClient from './ApiClient';

class LineStickerPackagesAPI extends ApiClient {
  constructor() {
    super('line_sticker_packages', { accountScoped: true });
  }

  // Use parent class get() which includes auth headers
  // Inherited from ApiClient

  update(packages) {
    // Use global axios which is configured with auth interceptors
    return axios.put(this.url, { packages });
  }
}

export default new LineStickerPackagesAPI();
